import { IFormaPago, MotivoRechazo } from "../administration"
import { Contrato } from "../global"
import { Naps, Sector, Zone } from "../mantenimiento-operaciones"
import { City, IPaymentMethodV2, Plan, Province } from "../system-settings"
import { IProspectoPymes } from "./prospecto_pymes.interface"

export interface IPreventaPymesResp {
  count: number
  next: string | null
  previous: string | null
  numero_paginas: number
  data: IPreventaPymes[]
}

export interface IPreventaPymes {
  id_preventa_pymes: string
  estado: boolean
  fecha_creacion: string
  fecha_modificacion: string
  codigo: string
  numero_referencia: string
  condicion_residencia: string | null
  direccion: string | null
  celular_2: string | null
  email: string | null
  persona_referencia_nombre: string | null
  persona_referencia_celular: string | null
  persona_referencia_celular_2: string | null
  persona_referencia_parentesco: string | null
  tipo_contrato: string
  tipo_plan: string
  tipo_servicio: string
  velocidad: string | null
  valor_plan: string
  tipo_instalacion: string
  valor_instalacion: string
  valor_plan_descuento: string
  valor_plan_iva: string
  valor_instalacion_descuento: string
  valor_instalacion_iva: string
  valor_plan_total: string
  valor_instalacion_total: string
  //coordenadas: CoordenadasPymes[]
  coordenadas: InfoPuntoEnlace[]
  promociones: string | null
  observaciones: {
    observacion_cancelar?: string;
    observacion_1: string;
    observacion_2: string;
  }
  url_foto_identificacion_delantera: string | null
  url_foto_identificacion_posterior: string | null
  url_foto_aceptacion: string | null
  url_foto_cuenta_bancaria: string | null
  url_foto_tarjeta: string | null
  url_foto_nombramiento: string | null
  url_foto_ruc: string | null
  url_foto_tutor_discapacidad: string | null
  url_autorizacion_debito_automatico: string | null
  url_autorizacion_cargo_tarjeta: string | null
  url_link_firma?: string | null
  no_tramite_firma?: string | null
  estado_preventa: string
  tarjeta_fecha_caducidad: string | null
  numero_cuenta: string | null
  numero_tarjeta: string | null
  tipo_cuenta_bancaria: string | null
  tipo_referido: string | null
  estado_referido: string | null
  estado_aceptacion: boolean
  os_aceptacion: string | null
  fecha_aceptacion: string | null
  es_android_tv: boolean
  numero_cuotas_android_tv: number
  precio_android_tv: string
  numero_cantidad_android_tv: number
  es_ups: boolean
  numero_cuotas_ups: number
  precio_ups: string
  numero_cantidad_ups: number
  es_router_ac: boolean
  numero_cuotas_router_ac: number
  requiere_wifi_6: boolean
  numero_cantidad_router_ac: number
  numero_cantidad_wifi_6: number
  numero_cuotas_wifi_6: number
  tipo_equipo: string | null
  estado_validacion: string | null
  linea: number
  errores: any
  require_facturacion: boolean
  requiere_contrato_fisico: boolean
  pre_requiere_contrato_fisico: boolean
  no_cobrar: boolean
  revisar_contrato: boolean
  fecha_aceptacion_referido: string | null
  os_aceptacion_referido: string | null
  fecha_pdf: string | null
  modulo_donde_creo: string | null
  valor_reconexion: string
  representante_legal_razon_social: string | null
  representante_legal_identificacion: string | null
  representante_celular1: string | null
  representante_celular2: string | null
  es_pago_total: boolean
  url_documentos_habilitantes: string | null
  nombre_pyme_enlace: string | null
  aplica_gremios: boolean
  email_facturacion: string | null
  tipo_autorizacion_debito: string | null
  identificacion_prospecto: string
  representante_legal_tipo_identificacion: string
  responsable_contable_tipo_identificacion: string | null;
  responsable_contable_identificacion: string | null;
  responsable_contable_razon_social: string | null;
  responsable_contable_celular: string | null;

  ///* fk
  cliente: string | null
  contrato: string | null
  prospecto: string
  provincia: string | null
  ciudad: string | null
  parroquia: string | null
  zona: string | null
  sector: string | null
  forma_pago: string | null
  plan: string | null
  entidad_financiera: string | null
  cooperativa: string | null
  tarjeta: string | null
  referido_flota: string | null
  referido_cliente: string | null
  flota?: string | null
  user_create: string | null
  empresa_create: string | null
  area_create: string | null
  departamento_create: string | null
  canal_venta_create: string | null
  nap: string | null
  motivo_rechazo: string | null
  solicitud_evento: string | null
  solicitud_canje: string | null
  fecha_inicio_contrato: string | null
  fecha_fin_contrato: string | null
  // V2 - 3 niveles de pago
  tipo_pago_v2: string | null
  forma_pago_v2: string | null
  forma_pago_legacy: string | null
  ///* data
  nap_data: Naps
  plan_data: Plan
  provincia_data: Province;
  ciudad_data: City;
  zona_data: Zone;
  sector_data: Sector;
  forma_pago_data: IFormaPago;
  forma_pago_v2_data: IPaymentMethodV2;
  prospecto_pymes_data: IProspectoPymes;
  motivo_rechazo_data: MotivoRechazo
  contrato_data: Omit<Contrato,
    'orden_trabajo_data'
    | 'agendamiento_data'
    | 'preagendamiento_data'
    | 'preventa_data'
    | 'cliente_data'> | null;
}

export interface IPreventaPymesParams extends Partial<IPreventaPymes> {
  page_size?: number
  page?: number
}

export interface IPreventaPymesForm extends Partial<IPreventaPymes> {
  items?: InfoPuntoEnlace[]
  codigo_forma_pago?: string;
  condicion_venta?: string
  observacion_1?: string;
  observacion_2?: string;
  unidad?: string;
  es_pyme?: boolean;
  servicio_correo?: string;
  email_temporal?: string;
  generar_pdf_contrato?: boolean;
  plan?: string;
  tiempo_contrato?: number;
  direccion_facturacion?: string;

  url_contrato?: string | null;
}

export interface InfoPuntoEnlace {
  codigo: string //
  estado: boolean
  nombre: string
  direccion: string
  coordenada: string
  lat?: string | null
  lng?: string | null
  cobertura?: boolean | null
  ///* plan
  plan?: string | null
  valor_plan?: string | null
  tipo_servicio?: string | null
  tipo_plan?: string | null
  velocidad_subida_maxima?: string

  ///* valor de instalacion 
  valor_instalacion?: string | null
  valor_instalacion_iva?: string | null
  valor_instalacion_total?: string | null
}

export const CoordenadasPymesDefault = '-0.32,-78.47'
